import React from 'react';

import { Box } from '@mui/material';

import { StyledTextField } from 'components/Input/styles';

import { StyledTitleText as TitleText } from 'containers/Dashboard/components/SideBar/components/Modals/FolderFormModalStyles';

import { RequiredMark } from './styles';

export const MAX_UNIT_NAME_LENGTH = 50;

export interface UnitNameFieldProps {
  value: string;
  error: string | null;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

const UnitNameField: React.FunctionComponent<UnitNameFieldProps> = ({ value, error, onChange, onSubmit }) => (
  <Box>
    <TitleText as="label" htmlFor="unit-name">
      Unit name <RequiredMark>*</RequiredMark>
    </TitleText>
    <StyledTextField
      id="unit-name"
      fullWidth
      autoFocus
      placeholder="Unit name"
      value={value}
      error={error !== null}
      helperText={error ?? undefined}
      inputProps={{ maxLength: MAX_UNIT_NAME_LENGTH }}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={(event) => {
        // preventDefault stops the same Enter reaching the button that opened the dialog once
        // focus returns to it, which would open the dialog again.
        if (event.key === 'Enter') {
          event.preventDefault();
          onSubmit();
        }
      }}
    />
  </Box>
);

export default UnitNameField;
